import Helmet from "react-helmet"
import React from "react"
import { capitalize } from "lodash"
import { PrimitiveType, useIntl } from "react-intl"
import { Maybe } from "../../types"
import { FormatXMLElementFn } from "intl-messageformat"

type Props = {
  title?: Maybe<string>
  raw?: boolean
  values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>
}

export default function PageTitle({ title, raw, values }: Props) {
  const intl = useIntl()
  const currentPageTitle = raw
    ? title || ""
    : title
      ? capitalize(intl.formatMessage({ id: title, defaultMessage: title }, values))
      : ""
  const pageTitle =
    title === "" ? null : intl.formatMessage({ id: "title", defaultMessage: title || "" })
  const suffix = pageTitle ? " • " + pageTitle : ""
  const displayTitle = currentPageTitle + suffix
  return <Helmet title={displayTitle} key={displayTitle} />
}
